import React from "react";
import { useLocation } from "react-router-dom";
import DynamicPackagesMaintenanceWall from "./DynamicPackagesMaintenanceWall.jsx";
import { evaluateHrDpRouteMaintenanceDecision } from "../../utils/dynamicPackage/dynamicPackagesMaintenanceGate.js";

/**
 * Route-level DP maintenance gate — same route paths; swaps element for Wall when flagged.
 */
const DynamicPackagesMaintenanceRouteGate = ({
  gateTriggered,
  children,
}) => {
  const { pathname } = useLocation();
  const decision = evaluateHrDpRouteMaintenanceDecision(pathname, gateTriggered);
  if (decision.blocked) {
    return <DynamicPackagesMaintenanceWall />;
  }
  return children;
};

export default DynamicPackagesMaintenanceRouteGate;
